export enum ErpAddressType {
	Delivery = 0,
	Invoice = 1,
	Personal = 2,
}
